"use client";

import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import SignOutButton from "./SignOutButton";

import NavItem from "./NavItem";
import MobileNavbarWrapper from "./MobileNavbarWrapper";
import { Menu } from "lucide-react";
import ThemeSwitchButton from "../Theme/ThemeSwitchButton";
import { useAuth } from "../auth/SessionWrapper";

export default function Navbar() {
  const { user, loading } = useAuth();

  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  const loadingContent = (
    <>
      <NavItem hrefTo="#" text="Carregando..." />
    </>
  );

  const loggedInContent = (
    <>
      <NavItem hrefTo="/" text="Início" />
      <NavItem hrefTo="/ver/certificados" text="Certificados" />
      <NavItem hrefTo="/ver/conhecimentos" text="Meu Conhecimento" />
      <NavItem hrefTo="/formulario" text="Editar Conhecimento" />
      <SignOutButton />
      <ThemeSwitchButton theme_style="adapt" />
    </>
  );

  const loggedOutContent = <></>;

  return (
    <header className="z-50">
      <nav className="bg-c-bg shadow-sm border-b-2 border-c-primary">
        <div className="pt-5 pb-4 px-12 flex justify-between space-x-2">
          {/* Left side */}
          <div className="flex space-x-5 mr-4">
            {/* Logo */}
            <Link href={"/"}>
              <Image
                src={"/company_logo.png"}
                alt="company logo"
                width={417 * 0.5}
                height={109 * 0.5}
                priority={true}
              />
            </Link>
            {/* Nav items */}
          </div>
          {/* Secondary Nav Items */}
          <div className="hidden md:flex item-center space-x-3">
            <div className="hidden md:flex item-center space-x-6">
              {loading
                ? loadingContent
                : user
                  ? loggedInContent
                  : loggedOutContent}
            </div>
          </div>

          {/* Mobile button */}
          <div className="mobile-menu-button md:hidden flex iems-center">
            <button onClick={handleClick}>
              <Menu className="h-6 w-6 text-c-text" />
            </button>
          </div>
        </div>
        {/* Mobile Menu */}
        <div className={`${isExpanded ? "block" : "hidden"} md:hidden`}>
          {loading ? (
            <MobileNavbarWrapper>
              <NavItem hrefTo="#" text="Carregando..." />
            </MobileNavbarWrapper>
          ) : (
            <>
              <MobileNavbarWrapper>
                <NavItem hrefTo="/" text="Início" />
              </MobileNavbarWrapper>
              {user && (
                <>
                  <MobileNavbarWrapper>
                    <NavItem hrefTo="/view" text="Meu Conhecimento" />
                  </MobileNavbarWrapper>
                  <MobileNavbarWrapper>
                    <NavItem hrefTo="/edit" text="Editar Conhecimento" />
                  </MobileNavbarWrapper>
                </>
              )}
              <MobileNavbarWrapper>
                <SignOutButton />
              </MobileNavbarWrapper>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
